import { request, trustedRequest, putRequest } from 'utils/request';

export const getAllBrands = () => trustedRequest('/catalogs/brands/all');

export const getAxDealers = () => trustedRequest('/catalogs/axdealers');

export const getExternalDealers = (accountId?: number) => {
  const url = accountId
    ? `/catalogs/externalDealers?account=${accountId}`
    : '/catalogs/externalDealers';
  return trustedRequest(url)
};

export const getBrands = () => trustedRequest('/catalogs/brands');

export const getModels = (id: number) => trustedRequest(`/catalogs/models/${id}`);

export const getYearsByModel = (id: number) => trustedRequest(`/catalogs/year/${id}`);

export const getBodiesByYear = (id: number) => trustedRequest(`/catalogs/body/${id}`);

export const getDealers = () => trustedRequest(`/catalogs/dealer`);

export const getEngines = () => trustedRequest('/catalogs/engines');

export const getGearboxes = () => trustedRequest('/catalogs/gearbox');

export const getControlStart = () => trustedRequest('/catalogs/controlstart');

export const getCountries = () => trustedRequest("/api/catalogs/countries");

export const getTips = () => request('/api/catalogs/tips', {});

export const getRecaptchaConfig = () => request('/api/config/recaptcha', {});

export const getBrandsNew = () => trustedRequest('/catalogs/brandsNew');

export const getModelsNew = (brandId: number) => trustedRequest(`/catalogs/modelsNew/${brandId}`);

export const getYearsNew = (modelId: number) => trustedRequest(`/catalogs/yearsNew/${modelId}`);

export const getBodiesNew = (yearId: number) => trustedRequest(`/catalogs/bodiesNew/${yearId}`);

export const getVinsByAccountParametrs = () => trustedRequest(`/catalogs/getVinsByAccountParametrs`);

export const getProductsByAccountParametrs = () => trustedRequest(`/catalogs/getProductsByAccountParametrs`);

export const getBrandsByAccountParametrs = () => trustedRequest(`/catalogs/getBrandsByAccountParametrs`);

export const getModelsByAccountParametrs = (body: { [key: string]: any }) =>
  putRequest(`/catalogs/getModelsByAccountParametrs`)(body);

export const getDealersByAccountParametrs = () => trustedRequest(`/catalogs/getDealersByAccountParametrs`);

export const getInstallationsDateRangeByAccountParametrs = () =>
  trustedRequest(`/catalogs/getInstallationsDateRangeByAccountParametrs`);
